export const generalResponse: GeneralResponseProps = {
  docs: [],
  totalDocs: 0,
  limit: 0,
  totalPages: 0,
  page: 0,
  pagingCounter: 0,
  hasPrevPage: false,
  hasNextPage: false,
  prevPage: 0,
  nextPage: 0,
};

export const generalRequest: GeneralRequest = {
  loading: false,
  success: '',
  error: '',
  message: '',
};

export interface GeneralResponseProps {
  docs: any[];
  totalDocs: number;
  limit: number;
  totalPages: number;
  page: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  prevPage: number | null;
  nextPage: number | null;
}

export interface DownloableFile {
  url: string;
}

export interface GeneralAsyncAction {
  callbackPre?: Function;
  callbackSuccess?: Function;
  callbackError?: Function;
}

export interface DropdownItem {
  label: string;
  value: string;
}

export interface GeneralRequest {
  loading: boolean;
  success?: string;
  error?: string;
  message?: unknown;
}
